import { Post } from "./Post";
import { iResource } from "@/interfaces/resources";

export class Resource extends Post<iResource> {
  //
}

export default Resource;
